function PDFPage6Table1(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-10">
                <thead>
                    <tr className="">
                        <th colSpan={8}>{props.TranslateString('Loans, indicative value estimation of the property and LTV')}</th>
                    </tr>
                    <tr className="cu-bg-green  ">
                        <th className="fw-600">{props.TranslateString('Loan name')}</th>
                        <th className="text-right fw-600 text-nowrap">{props.TranslateString('Capital')}</th>
                        <th className="text-right fw-600 ">{props.TranslateString('Estimated value, average')}</th>
                        <th className="text-right fw-600 ">{props.TranslateString('Estimated value, lower quartile')}</th>
                        <th className="text-right fw-600 ">{props.TranslateString('Estimated value, upper quartile')}</th>
                        <th className="text-right fw-600 " style={{minWidth:"70px"}}>{props.TranslateString('LTV')}</th>
                        <th className="text-right fw-600 " style={{minWidth:"70px"}}>{props.TranslateString('LTV min')}</th>
                        <th className="text-right fw-600 " style={{minWidth:"70px"}}>{props.TranslateString('LTV max')}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    {
                        props?.loanData?.map((element:any,index:any)=>{
                            return (
                                <tr key={index+Math.random()}>
                                    <td>{element?.loan_data_name}</td>
                                    <td className="text-right">{element?.loan_data_loan_value}</td>
                                    <td className="text-right">{element?.indicative_price}</td>
                                    <td className="text-right">{element?.quartile_25}</td>
                                    <td className="text-right">{element?.quartile_75}</td>
                                    <td className="text-right">{element?.ltv}</td>
                                    <td className="text-right">{element?.ltv_min}</td>
                                    <td className="text-right">{element?.ltv_max}</td>
                                </tr>
                            );
                        })
                    }
                    {props?.loanData?.length > 0 && props?.loanData_total ?
                        <tr>
                            <th className="text-capitalize fw-600">{props.TranslateString("Total")}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.loan_value_total || "0.00"}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.price_total || 0}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.quartile_25_total}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.quartile_75_total}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.ltv_total}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.ltv_min_total}</th>
                            <th className="text-right fw-600">{props?.loanData_total?.ltv_max_total}</th>
                        </tr>
                    :""}
                </tbody>
            </table>
        </>
    );
}

export default PDFPage6Table1;